import axios from 'axios';
export const API = process.env.REACT_APP_BACKEND_URL + '/api';
export const api = axios.create({baseURL:API,withCredentials:true});
export const message = e => typeof e.response?.data?.detail === 'string' ? e.response.data.detail : 'Something went wrong. Please check your details and try again.';
export const photoUrl = id => id ? `${API}/files/${id}` : null;
export const POSITIONS = ['Hitting','Pitching','Catcher','1st base','2nd base','3rd base','Shortstop','Left field','Center field','Right field'];
export const FAMILIES = ['hitting','pitching','catching','infield','outfield'];
export const covers = [
 'https://images.unsplash.com/photo-1624375664562-fff61869fe8f?auto=format&fit=crop&w=900&q=85',
 'https://images.unsplash.com/photo-1489460427746-b6296f4bc3f5?auto=format&fit=crop&w=900&q=85',
 'https://images.unsplash.com/photo-1654094706120-be054b9ef237?auto=format&fit=crop&w=900&q=85',
 'https://images.unsplash.com/photo-1624375812928-106472d9ddb9?auto=format&fit=crop&w=900&q=85'
];
export const dateLabel = d => d ? new Date(d.length===10?d+'T12:00:00':d).toLocaleDateString('en-US',{month:'short',day:'numeric',year:'numeric'}) : '—';